import React, { useEffect, useState } from 'react';
import { adminTabelaGet, adminTabelaUpload } from '../../lib/api';

const TabelaPrecosSection = () => {
  const [info, setInfo] = useState(null);
  const [busy, setBusy] = useState(null);
  const [msg, setMsg] = useState(null);

  const carregar = () => adminTabelaGet().then(setInfo);
  useEffect(() => { carregar(); }, []);

  const enviar = async (id, file) => {
    if (!file) return;
    setBusy(id); setMsg(null);
    try {
      const r = await adminTabelaUpload(id, file);
      setMsg({ ok: true, text: `Tabela importada: ${r.linhas} faixas de CEP.` });
      await carregar();
    } catch (err) {
      setMsg({ ok: false, text: err?.response?.data?.detail || 'Erro ao importar a planilha.' });
    } finally { setBusy(null); }
  };

  return (
    <section className="bg-white rounded-2xl border border-slate-100 p-6 max-w-2xl">
      <h2 className="text-lg font-semibold text-slate-900">Tabela de preços do contrato</h2>
      <p className="text-sm text-slate-500 mb-5">
        Origem {info?.origem || 'Fortaleza-CE'}. Envie o CSV de cada serviço; o novo arquivo substitui a tabela anterior.
        A margem de lucro é aplicada por cima destes valores.
      </p>
      <div className="space-y-4">
        {(info?.servicos || []).map((sv) => (
          <div key={sv.id} className="flex flex-wrap items-center justify-between gap-3 border border-slate-100 rounded-xl p-4">
            <div>
              <p className="font-semibold text-slate-900">{sv.nome}</p>
              <p className="text-xs text-slate-500">
                {sv.linhas > 0
                  ? `${sv.linhas} faixas de CEP · atualizada em ${sv.atualizado_em ? new Date(sv.atualizado_em).toLocaleString('pt-BR') : '-'}`
                  : 'Nenhuma tabela importada'}
              </p>
            </div>
            <label className="inline-flex items-center px-4 h-9 rounded-full border border-slate-200 text-sm font-medium text-slate-700 hover:bg-slate-50 cursor-pointer">
              {busy === sv.id ? 'Importando...' : 'Enviar CSV'}
              <input type="file" accept=".csv" className="hidden" disabled={busy !== null}
                onChange={(e) => { enviar(sv.id, e.target.files[0]); e.target.value = ''; }} />
            </label>
          </div>
        ))}
      </div>
      {msg && <p className={`text-sm mt-4 ${msg.ok ? 'text-emerald-600' : 'text-red-600'}`}>{msg.text}</p>}
    </section>
  );
};

export default TabelaPrecosSection;
